import { Component, computed, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'lib-ikp-info-tooltip',
  imports: [NgbTooltip, TranslatePipe],
  templateUrl: './info-tooltip.component.html',
})
export class InfoTooltipComponent {
  tooltipText = input.required<string>();
  buttonId = input<string>();
  category = input<'primary' | 'secondary'>('primary');
  size = input<'md' | 'sm' | 'xs'>('sm');
  placement = input<'top' | 'left' | 'right' | 'bottom' | 'auto'>('auto');
  dataTest = input<string>();

  btnCssClasses = computed<string>(() => `btn btn-${this.category()}--dark-blue btn-icon btn-${this.size()}`);
}
